import React, { useEffect, useState } from "react";
import { Button } from "@agria/theme/src/components/button";
import { myAccountConfig } from "@agria/theme-my-account/src/const/myAccountConfig";
import { useMyAccount } from "@agria/theme-my-account/src/context/MyAccountContext";
import { getCookie, setCookie } from "@agria/utils";
import Share from "@agria/theme/src/components/share/Share";
import Stack from "@agria/theme/src/components/stack/Stack";
import { Input } from "@agria/theme/src/components/form/input/Input";
import Alert from "@agria/theme/src/components/alert/Alert";
import { handleCopyClick } from "@agria/theme/src/utils/copyToClipboard";
import { Typography } from "@agria/theme/src/components/typography/Typography";
import { myAccountLinks } from "@agria/theme-my-account/src/const/myAccountLinks";
import Link from "@agria/theme/src/components/link/Link";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import LinkTo from "@agria/theme/src/components/linkTo/LinkTo";

const StyledForm = styled(Stack)`
  ${({ theme: { space } }) => css`
    width: 100%;
  `};
`;

const StyledGenerateLink = styled(Stack)`
  ${({ theme: { space } }) => css`
    width: 100%;
  `};
`;


export const ReferAFriend = () => {
  const { customer } = useMyAccount();
  const [existingLink, setExistingLinkGenerated] = useState<string>("");
  const [linkGenerated, setLinkGenerated] = useState<string>("");
  const [linkGenerateError, setLinkGenerateError] = useState(false);
  const [isGeneratingLink, setIsGeneratingLink] = useState(false);
  const referLink = `${myAccountConfig.referAFriendUrl}&UID=${customer?.Id}`;

  const generateReferLink = () => {
    if (!customer?.Id) {
      setLinkGenerateError(true);
      return;
    }

    setLinkGenerated(referLink);
    setIsGeneratingLink(false);
    setCookie("referLink", referLink, 30);
  };

  useEffect(() => {
    const referSavedLink = getCookie("referLink");

    if (referSavedLink) {
      setExistingLinkGenerated(referSavedLink);
    }
  }, []);

  return (
    <>
      {!linkGenerated && !existingLink && (
        <StyledGenerateLink>
          <Typography component="p">
            By clicking on the Generate your link button you acknowledge that
            you have read and accept the <LinkTo to={myAccountLinks.referAFriendTerms} label="Terms and conditions"/> of this promotion.
          </Typography>
          <Stack gap="medium">
            <Button
              variant="primary"
              as="button"
              isLoading={isGeneratingLink}
              onClick={generateReferLink}
            >
              Generate your link
            </Button>
            {linkGenerateError && (
              <Alert variant="warning" text="Unable to generate link" />
            )}
          </Stack>
        </StyledGenerateLink>
      )}
      {(linkGenerated || existingLink) && (
        <StyledForm gap="large">
          {!existingLink && (
            <Alert
              variant="success"
              text="Your unique refer a friend link has been generated."
            />
          )}
          <Input
            id="referCopyLink"
            label=""
            value={existingLink || linkGenerated}
            type="text"
            onChange={() => {}}
          />
          <Button
            onClick={() =>
              handleCopyClick(existingLink || linkGenerated).then(() => {})
            }
            type="button"
            variant="secondary"
          >
            Copy link
          </Button>
          {existingLink && (
            <Share
              shareText="Refer a friend link"
              url={existingLink}
              platforms={["facebook", "twitter"]}
            />
          )}
        </StyledForm>
      )}
    </>
  );
};
